import {Button} from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {AccessDeniedBlock} from "@/pages/website/components/AccessDeniedBlock.tsx";

export const FeatureUnavailablePage = () => {
  const {user} = useCurrentUserContext();

  return (
    <AccessDeniedBlock title="Feature Unavailable">
      <div className={"d-flex flex-column align-items-center"}>
        <div className="fw-bold fs-5">This feature is unavailable on your current subscription</div>
        {user?.is_primary ? (
          <>
            <div className="mt-2">
              This happened either because you've already utilized your allocated limits or because it's a feature that
              is not available in your current subscription.
            </div>
            <div className="mt-2">
              No worries though! You can easily upgrade your subscription by clicking the Upgrade Now button below.
            </div>
            <div className="mt-2">If you have any questions don't hesitate to contact us.</div>
            <div className="mt-4">
              <Button as={"a"} href="/billing/subscribe">
                Upgrade Now
              </Button>
            </div>
            <hr className="my-4" />
          </>
        ) : (
          <div className="mt-2">
            Please feel free to have your account owner{" "}
            {user?.account && (
              <div>
                <a className="text-black fw-semibold" href={`mailto:${user.account.primary_user_email}`}>
                  {user.account.primary_user_name} ({user.account.primary_user_email})
                </a>
              </div>
            )}
            upgrade your subscription to get access to this feature.
          </div>
        )}
      </div>
    </AccessDeniedBlock>
  );
};
